import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTarget, FiPlus, FiCheck, FiClock, FiTrendingUp } = FiIcons;

const InspirationSection = ({ onRandomizeAll, onRandomizeField }) => {
  const fields = [
    { name: 'composition', label: 'Composition' },
    { name: 'cameraMovement', label: 'Camera' },
    { name: 'visualStyle', label: 'Style' },
    { name: 'lighting', label: 'Lighting' },
    { name: 'environment', label: 'Setting' },
    { name: 'audio', label: 'Audio' },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="clay-card p-6 mb-8"
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-4">
        <div>
          <h2 className="text-xl font-bold neon-text">✨ Need Inspiration?</h2>
          <p className="text-gray-300 text-sm">Randomize all fields or just the ones you need</p>
        </div>
        
        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={onRandomizeAll}
          className="btn-primary clay-button py-3 px-6 font-medium flex items-center gap-2 highlight-hover w-full md:w-auto"
        >
          <SafeIcon icon={FiTarget} className="text-lg" />
          <span>Randomize All Fields</span>
        </motion.button>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
        {fields.map((field) => (
          <motion.button
            key={field.name}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onRandomizeField(field.name)}
            className="clay-button px-3 py-2 text-sm text-gray-300 highlight-hover flex items-center justify-center gap-1"
          >
            <SafeIcon icon={FiTarget} className="text-xs" />
            <span>{field.label}</span>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default InspirationSection;